webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(17)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(29),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = {
	"members": [
		{
			"name": "Rafał Krukowski",
			"description": "Jak zawsze niezdecydowany i bez grosza przy duszy. Na larpach woli stać w cieniu, nie lubi być w centrum uwagi. Na każdego larpa posiada milion planów na które i tak nie posiada sił ani środków. Rafał ma jedną zaletę, na prawie każdym larpie potrafi efektowanie zginąć. Poza larpem przywozi dobry bimber",
			"nick": "Sigwar",
			"img": "http://i.imgur.com/sbdCQWd.png"
		},
		{
			"name": "Szymon Gąsior",
			"description": "Z zawodu ratownik medyczny, na larpach oddaje się całym sobą dzięki czemu potrafi się wczuć w kazdą rolę. Ulubionym zajęciem Szymona jest gawędzenie z innymi graczami. Jest to postać bardzo charyzmatyczna, potrafi wcisnąć kit niejednej osobie. W wolnych chwilach przesiaduje w karczmie przepija albo przegrywa w pokera cały żołd.",
			"nick": "Aima",
			"img": "http://i.imgur.com/mXuWlkY.png"
		},
		{
			"name": "Patryk Konieczny",
			"description": "Założyciel grupy Krasja. Pracuje jako specjalista ds. technicznych w PCC Polska. Z pozoru łysy Kubuś puchatek, ale tylko z pozoru. Dzięki dużemu doświadczeniu Patryk lubi grać dowódce grupy. Zazwyczaj wszystko idzie po jego myśli, dopóki nie ma pieniędzy aby płacić żołd swoim żołnierzom",
			"nick": "Harun",
			"img": "http://i.imgur.com/u9cIRJy.png"
		},
		{
			"name": "Kacper Blak",
			"description": "Na larpach Kacper jest zwyczajnym graczem który w lewej ręce posiada fach a w prawej butelkę alkoholu. ",
			"nick": "Blaku",
			"img": "http://i.imgur.com/K1zeWgH.png"
		},
		{
			"name": "Kuba Bednarczuk",
			"description": "Jeden z młodszych członków grupy Krasja. Niech was nie zmyli ta słodka buźka, jeżeli zobaczycie krecącego się gdzieś Kube możecie podejrzewać go, że w swoijej kieszeni już ma wasze złoto. Na larpach nie ma  chyba lepszego złodzieja niż on. Jego gra polega na siedzeniu w karczmie i obmyślaniu planu jak ogołocić następną ofiarę.",
			"nick": "Amir",
			"img": "http://i.imgur.com/Amn4B4R.png"
		},
		{
			"name": "Paweł Kisiński",
			"description": "Drugi najmłodszy członek grupy Krasja. Paweł zazwyczaj trzyma się razem z Kubą. Razem tworzą niestabilną mieszankę która może w każdej chwili eksplodować. Na larpach Paweł wydaje się cichym graczem i taki właśnie jest. Nie zwraca na siebie uwagi jednak czasami podsłyszy przydatne informacje.",
			"nick": "Kwasior",
			"img": "http://i.imgur.com/Ruz7a1n.png"
		}
	],
	"events": [
		{
			"title": "Fort 2016",
			"fraction": " Łowcy nieumarłych",
			"target": " Wytropić grasującego w Ransfield nekromantę, oczyścić teren z żywych trupów. ",
			"description": "Fragment dziennika: Od przybycia do Ransfield zaczęły nawiedzać nas spętane duchy, widać nekromanta spodziewa się, że ktoś na niego poluje. Zwerbowałem w tej mieścinie kilkoro ludzi i tylko połowa przeżyła rytuał Dołaczenia. Sytuacja jest ciężka, może wręcz tragiczna. Jednak z gorszych opresji udawało się wychodzić obronną ręką.",
			"img": "http://i.imgur.com/geSDfhT.png"
		},
		{
			"title": "Fantazjada 2015",
			"fraction": "Południowy Emirat",
			"target": " Odzyskanie skradzionego przez Sabat amuletu.",
			"description": "Posłuchaj, dobra?! Mówię Ci! Gadałem z jednym z nich, szukają jakiegoś cholernego amuletu, Hans mówi, że nawet jakiegoś chłopa torturowali, chodzą wściekli na cały Einburg, każdemu zaglądają do kieszeni albo i głębiej! Jedynym plusem jest to, że zaciukali kilka bestyi, a i jakieś ichniejsze owoce nawieźli, całkiem to dobre!",
			"img": "http://i.imgur.com/jM9FDMC.png"
		},
		{
			"title": "Gothic 2014",
			"fraction": "Asasyni",
			"target": " Odnaleźć artefakt Beliara",
			"description": "Ja Imur'al Preslafa zaklinam was! Dzielny ludu Varrantu! Odnajdźcie w sobie odwagę i ruszajcie na wyspy Khorinis! Albowiem wielki Beliar objawił się dziś w nocy i objaśnił, że na wyspach znajduje się potężny artefakt, który winien spocząć w świątyni, w samym Ishtar! Zaś plugawi magowie ognia pragną położyć na nim swoje brudne łapska i go zniszczyć! Ruszajcie dzielny ludu Varrantu!",
			"img": "http://i.imgur.com/lmK1SYH.png"
		}
	]
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_homeView_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_homeView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_homeView_vue__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_homeView_vue___default.a
  }]
}));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(15)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(27),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(4);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_homeView_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_homeView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_homeView_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    home: __WEBPACK_IMPORTED_MODULE_0__views_homeView_vue___default.a
  }
});

/***/ }),
/* 8 */
/***/ (function(module, exports) {



/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_json_data_json__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_json_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_json_data_json__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dataMembers: {
        name: __WEBPACK_IMPORTED_MODULE_0__static_json_data_json___default.a.members[0].name,
        description: __WEBPACK_IMPORTED_MODULE_0__static_json_data_json___default.a.members[0].description,
        nick: __WEBPACK_IMPORTED_MODULE_0__static_json_data_json___default.a.members[0].nick,
        img: __WEBPACK_IMPORTED_MODULE_0__static_json_data_json___default.a.members[0].img
      },
      activeSigwar: true,
      activeHarun: false,
      activeAima: false,
      activeBlaku: false,
      activeAmir: false,
      activeKwasior: false
    };
  },

  methods: {
    write: function write(arg) {
      this.dataMembers.name = __WEBPACK_IMPORTED_MODULE_0__static_json_data_json___default.a.members[arg].name;
      this.dataMembers.description = __WEBPACK_IMPORTED_MODULE_0__static_json_data_json___default.a.members[arg].description;
      this.dataMembers.nick = __WEBPACK_IMPORTED_MODULE_0__static_json_data_json___default.a.members[arg].nick;
      this.dataMembers.img = __WEBPACK_IMPORTED_MODULE_0__static_json_data_json___default.a.members[arg].img;

      switch (arg) {
        case 0:
          this.activeSigwar = true;
          this.activeAima = false;
          this.activeBlaku = false;
          this.activeHarun = false;
          this.activeAmir = false;
          this.activeKwasior = false;
          break;
        case 1:
          this.activeSigwar = false;
          this.activeAima = true;
          this.activeBlaku = false;
          this.activeHarun = false;
          this.activeAmir = false;
          this.activeKwasior = false;
          break;
        case 2:
          this.activeSigwar = false;
          this.activeAima = false;
          this.activeBlaku = false;
          this.activeHarun = true;
          this.activeAmir = false;
          this.activeKwasior = false;
          break;
        case 3:
          this.activeSigwar = false;
          this.activeAima = false;
          this.activeBlaku = true;
          this.activeHarun = false;
          this.activeAmir = false;
          this.activeKwasior = false;
          break;
        case 4:
          this.activeSigwar = false;
          this.activeAima = false;
          this.activeBlaku = false;
          this.activeHarun = false;
          this.activeAmir = true;
          this.activeKwasior = false;
          break;
        case 5:
          this.activeSigwar = false;
          this.activeAima = false;
          this.activeBlaku = false;
          this.activeHarun = false;
          this.activeAmir = false;
          this.activeKwasior = true;
          break;
      }
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 11 */
/***/ (function(module, exports) {



/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_json_data_json__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_json_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_json_data_json__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      larps: __WEBPACK_IMPORTED_MODULE_0__static_json_data_json___default.a.events
    };
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AboutUs_aboutUs_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AboutUs_aboutUs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AboutUs_aboutUs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Members_members_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Members_members_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Members_members_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_endContent_endContent_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_endContent_endContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_endContent_endContent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_events_events_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_events_events_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_events_events_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_endOfPage_endOfPage_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_endOfPage_endOfPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_endOfPage_endOfPage_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    aboutus: __WEBPACK_IMPORTED_MODULE_0__components_AboutUs_aboutUs_vue___default.a,
    members: __WEBPACK_IMPORTED_MODULE_1__components_Members_members_vue___default.a,
    endContent: __WEBPACK_IMPORTED_MODULE_2__components_endContent_endContent_vue___default.a,
    events: __WEBPACK_IMPORTED_MODULE_3__components_events_events_vue___default.a,
    endOfPage: __WEBPACK_IMPORTED_MODULE_4__components_endOfPage_endOfPage_vue___default.a
  }
});

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(19)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(31),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(20)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(32),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(16)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(28),
  /* scopeId */
  "data-v-374e5b02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(14)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(26),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(18)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(30),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "endOfPage"
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer_media"
  }, [_vm._v("\n      Media:\n\n      "), _c('div', {
    staticClass: "footer_media_icons"
  }, [_c('a', {
    staticClass: "footer_media_icons_social_media footer_media_icons_social_media--facebook",
    attrs: {
      "href": "https://www.facebook.com/Larp-Group-Krasja-1415785175113800/"
    }
  }, [_vm._v("facebook")]), _vm._v(" "), _c('a', {
    staticClass: "footer_media_icons_social_media footer_media_icons_social_media--youtube",
    attrs: {
      "href": "https://www.youtube.com/watch?v=OhOmeYdvYdk"
    }
  }, [_vm._v("youtube")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer_icon"
  }, [_c('img', {
    staticClass: "footer_icon_img",
    attrs: {
      "src": "http://i.imgur.com/Og6KzKR.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer_media_contact"
  }, [_vm._v("\n      Kontakt:\n\n\n      "), _c('div', {
    staticClass: "footer_media_contact_phone"
  }, [_c('a', {
    staticClass: " footer_media_contact_phone_owner",
    attrs: {
      "href": "tel: 570267495"
    }
  }, [_vm._v("725 085 596")])]), _vm._v(" "), _c('div', {
    staticClass: "footer_media_contact_email"
  }, [_c('a', {
    staticClass: " footer_media_contact_email_owner",
    attrs: {
      "href": "mailto: koniecznyprecel@hotmail.com"
    }
  }, [_vm._v("kkrasja@gmail.com")])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer_author"
  }, [_c('h1', [_vm._v("Created by "), _c('a', {
    staticClass: "footer_author_link",
    attrs: {
      "href": "http://rafal-krukowski.c0.pl/"
    }
  }, [_vm._v("Rafał Krukowski")])])])])
}]}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('home')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header",
    attrs: {
      "id": "home"
    }
  }, [_c('nav', {
    staticClass: "header_navbar"
  }, [_c('ul', {
    staticClass: "header_navbar_menu"
  }, [_c('li', {
    staticClass: "header_navbar_menu_link"
  }, [_c('a', {
    staticClass: "header_navbar_menu_link_href",
    attrs: {
      "href": "#home"
    }
  }, [_vm._v("Strona Główna")])]), _vm._v(" "), _c('li', {
    staticClass: "header_navbar_menu_link"
  }, [_c('a', {
    staticClass: "header_navbar_menu_link_href",
    attrs: {
      "href": "#aboutUs"
    }
  }, [_vm._v("O nas")])]), _vm._v(" "), _c('li', {
    staticClass: "header_navbar_menu_link"
  }, [_c('a', {
    staticClass: "header_navbar_menu_link_href",
    attrs: {
      "href": "#members"
    }
  }, [_vm._v("Nasza kompania")])]), _vm._v(" "), _c('li', {
    staticClass: "header_navbar_menu_link"
  }, [_c('a', {
    staticClass: "header_navbar_menu_link_href",
    attrs: {
      "href": "#events"
    }
  }, [_vm._v("Larpy")])])])]), _vm._v(" "), _c('div', {
    staticClass: "header_title"
  }, [_c('h1', {
    staticClass: "header_title_name"
  }, [_vm._v("KRASJA")]), _vm._v(" "), _c('hr', {
    staticClass: "header_title_line"
  }), _vm._v(" "), _c('h2', {
    staticClass: "header_title_slogan"
  }, [_vm._v(" Daj się porwać w wir przygody!")])])])
}]}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "endContent"
  }, [_c('div', {
    staticClass: "endContent_circle"
  }, [_c('img', {
    staticClass: "endContent_circle_img",
    attrs: {
      "src": "http://i.imgur.com/Izl594b.png"
    }
  })])])
}]}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "main_content"
  }, [_c('div', {
    staticClass: "main_content_title",
    attrs: {
      "id": "aboutUs"
    }
  }, [_vm._v("\n        GRUPA KRASJA\n      ")]), _vm._v(" "), _c('aboutus'), _vm._v(" "), _c('members'), _vm._v(" "), _c('endContent')], 1)]), _vm._v(" "), _c('events'), _vm._v(" "), _c('endOfPage')], 1)
},staticRenderFns: []}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [_c('div', {
    staticClass: "events_section",
    attrs: {
      "id": "events"
    }
  }, [_c('div', {
    staticClass: "events_section_container"
  }, [_c('div', {
    staticClass: "events_section_container_event"
  }, [_c('img', {
    staticClass: "events_section_container_event_img",
    attrs: {
      "src": _vm.larps[2].img
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "events_section_container_event_title"
  }, [_vm._v("\n          " + _vm._s(_vm.larps[2].title) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "events_section_container_event_descriptio"
  }, [_vm._v("\n          Frakcja: " + _vm._s(_vm.larps[2].fraction)), _c('br'), _vm._v("\n          Cel: " + _vm._s(_vm.larps[2].target) + " "), _c('br'), _c('br'), _vm._v("\n          " + _vm._s(_vm.larps[2].description) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "events_section_container"
  }, [_c('div', {
    staticClass: "events_section_container_event"
  }, [_c('img', {
    staticClass: "events_section_container_event_img",
    attrs: {
      "src": _vm.larps[1].img
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "events_section_container_event_title"
  }, [_vm._v("\n          " + _vm._s(_vm.larps[1].title) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "events_section_container_event_descriptio"
  }, [_vm._v("\n          Frakcja: " + _vm._s(_vm.larps[1].fraction)), _c('br'), _vm._v("\n          Cel: " + _vm._s(_vm.larps[1].target) + " "), _c('br'), _c('br'), _vm._v("\n          " + _vm._s(_vm.larps[1].description) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "events_section_container"
  }, [_c('div', {
    staticClass: "events_section_container_event"
  }, [_c('img', {
    staticClass: "events_section_container_event_img",
    attrs: {
      "src": _vm.larps[0].img
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "events_section_container_event_title"
  }, [_vm._v("\n          " + _vm._s(_vm.larps[0].title) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "events_section_container_event_descriptio"
  }, [_vm._v("\n          Frakcja: " + _vm._s(_vm.larps[0].fraction)), _c('br'), _vm._v("\n          Cel: " + _vm._s(_vm.larps[0].target) + " "), _c('br'), _c('br'), _vm._v("\n          " + _vm._s(_vm.larps[0].description) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "aboutUs_description"
  }, [_c('p', {
    staticClass: "aboutUs_description_title"
  }, [_vm._v("O NAS")]), _vm._v(" "), _c('p', {
    staticClass: "aboutUs_description_description"
  }, [_vm._v("\n      Każdy z nas jest orginalny na swój sposób. Czasami nasza charakterność daje się we znaki co powoduje sprzeczki. Jednakże gdy zbliża się czas w którym trzeba współpracować potrafimy jednomyślnie podejmować decyzje.\n      Możemy Ci obiecać że z nami nigdy nie będziesz się nudził podczas larpowania.\n      Nikt nie narzuca swoich reguł co do odgrywania postaci, daj pomysł a my go wcielimy w życie. Poza larpowaniem jesteśmy paczką znajomych którzy trzymają ze sobą dobry kontakt.\n     ")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutUs_line"
  }, [_c('div', {
    staticClass: "aboutUs_line_circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "aboutUs_line_hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "aboutUs_logo"
  }, [_c('img', {
    staticClass: "aboutUs_logo_img",
    attrs: {
      "src": "http://i.imgur.com/Izl594b.png"
    }
  })])])
}]}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "members",
    attrs: {
      "id": "members"
    }
  }, [_c('div', {
    staticClass: "members_image"
  }, [_c('div', {
    staticClass: "members_image_content"
  }, [_c('img', {
    staticClass: "members_image_content_img",
    attrs: {
      "src": _vm.dataMembers.img
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "members_image_content_name"
  }, [_vm._v(_vm._s(_vm.dataMembers.nick))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "members_description"
  }, [_c('p', {
    staticClass: "members_description_title"
  }, [_vm._v("NASZA KOMPANIA")]), _vm._v(" "), _c('ul', {
    staticClass: "mmembers_description_list"
  }, [_c('li', {}, [_c('a', {
    staticClass: "list list-axe list--img list_img-axe",
    class: {
      active: _vm.activeSigwar
    },
    on: {
      "click": function($event) {
        _vm.write(0)
      }
    }
  })]), _vm._v(" "), _c('li', {}, [_c('a', {
    staticClass: "list list-sword list--img list_img-sword",
    class: {
      active: _vm.activeAima
    },
    on: {
      "click": function($event) {
        _vm.write(1)
      }
    }
  })]), _vm._v(" "), _c('li', {}, [_c('a', {
    staticClass: "list list-mace list--img list_img-mace",
    class: {
      active: _vm.activeHarun
    },
    on: {
      "click": function($event) {
        _vm.write(2)
      }
    }
  })]), _vm._v(" "), _c('li', {}, [_c('a', {
    staticClass: "list list-wand list--img list_img-wand",
    class: {
      active: _vm.activeBlaku
    },
    on: {
      "click": function($event) {
        _vm.write(3)
      }
    }
  })]), _vm._v(" "), _c('li', {}, [_c('a', {
    staticClass: "list list-dagger list--img list_img-dagger",
    class: {
      active: _vm.activeAmir
    },
    on: {
      "click": function($event) {
        _vm.write(4)
      }
    }
  })]), _c('li', {}, [_c('a', {
    staticClass: "list list-shield list--img list_img-shield",
    class: {
      active: _vm.activeKwasior
    },
    on: {
      "click": function($event) {
        _vm.write(5)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "members_description_name_person"
  }, [_c('div', {
    staticClass: "members_description_name_person_hr"
  }), _vm._v(" "), _c('h2', {
    staticClass: "members_description_name_person_title"
  }, [_vm._v("\n        " + _vm._s(_vm.dataMembers.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "members_description_name_person_hr"
  })]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n      " + _vm._s(_vm.dataMembers.description) + "\n      ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "members_image_content_hr"
  }, [_c('div', {
    staticClass: "members_image_content_hr_left"
  }), _vm._v(" "), _c('div', {
    staticClass: "members_image_content_hr_right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "members_line"
  }, [_c('div', {
    staticClass: "members_line_circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "members_line_hr"
  })])
}]}

/***/ })
],[6]);


// WEBPACK FOOTER //
// static/js/app.7e8a1d41998fbbb5c749.js